import React from 'react';
import { Formik } from 'formik';
import { Container, Row, Col, Form } from 'react-bootstrap';
import Button from '../common/button';
import PasswordRules from '../common/PasswordRules';
import { LoginSVG } from '../../img/GlobalSVG';

const PasswordReset = ({
  currentStep,
  nextStep,
  passwordSchema,
  passwordRules,
  showPassword,
  showConfirmPassword,
  setShowPassword,
  setShowConfirmPassword,
  formData,
  handleInput,
}) => {
  console.log('currentStep', currentStep);
  return currentStep === 2 ? (
    <Col
      className="password-reset-container password-reset-container-box"
      md={8}
    >
      <Row>
        <Col md={12}>
          <Formik
            validationSchema={passwordSchema}
            initialValues={{
              password: formData.password || '',
              confirmPassword: formData.confirmPassword || '',
            }}
            onSubmit={(values, actions) => {
              nextStep();
            }}
          >
            {({
              values,
              touched,
              errors,
              status,
              handleSubmit,
              handleChange,
              handleBlur,
              setStatus,
              setFieldValue,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={12}>
                      <Form.Group className="position-relative mb-0">
                        <Form.Label className="mb-0">
                          New Password <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type={showPassword ? 'text' : 'password'}
                          name="password"
                          placeholder=""
                          className={
                            status && status.password ? 'is-invalid' : ''
                          }
                          value={formData.password}
                          isInvalid={errors.password}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                        />
                        <div className="span-right-showpassword">
                          <span
                            role={'button'}
                            onClick={(event) => {
                              setShowPassword(!showPassword);
                            }}
                            onKeyPress={(event) => {
                              setShowPassword(!showPassword);
                            }}
                            tabIndex={0}
                          >
                            {showPassword ? (
                              <LoginSVG.DisplayPasswordSVG />
                            ) : (
                              <LoginSVG.HidePasswordSVG />
                            )}
                          </span>
                        </div>
                        {status && status.password ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.password}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.password && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{errors.password}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  {formData?.SuperUser !== true && (
                    <Row>
                      <Col md={12}>
                        <PasswordRules
                          touched={touched.password}
                          fieldValue={formData.password}
                          rules={passwordRules}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row className="mt-3">
                    <Col md={12}>
                      <Form.Group className="position-relative mb-4">
                        <Form.Label className="mb-0">
                          Confirm Password{' '}
                          <span className="form-required">*</span>
                        </Form.Label>
                        <Form.Control
                          type={showConfirmPassword ? 'text' : 'password'}
                          name="confirmPassword"
                          placeholder=""
                          className={
                            status && status.confirmPassword ? 'is-invalid' : ''
                          }
                          value={formData.confirmPassword}
                          isInvalid={errors.confirmPassword}
                          onChange={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                          onBlur={(e) => {
                            handleInput(e, setFieldValue, handleChange);
                          }}
                        />
                        <div className="span-right-showpassword">
                          <div
                            role={'button'}
                            onClick={(event) => {
                              setShowConfirmPassword(!showConfirmPassword);
                            }}
                            onKeyPress={(event) => {
                              setShowConfirmPassword(!showConfirmPassword);
                            }}
                            tabIndex={0}
                          >
                            {showConfirmPassword ? (
                              <LoginSVG.DisplayPasswordSVG />
                            ) : (
                              <LoginSVG.HidePasswordSVG />
                            )}
                          </div>
                        </div>
                        {status && status.confirmPassword ? (
                          <Form.Control.Feedback
                            type="invalid"
                            className="mt-1"
                          >
                            <span>{status.confirmPassword}</span>
                          </Form.Control.Feedback>
                        ) : (
                          errors.confirmPassword && (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{errors.confirmPassword}</span>
                            </Form.Control.Feedback>
                          )
                        )}
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12}>
                      <Button type="submit" className="float-right mt-2">
                        Continue
                      </Button>
                    </Col>
                  </Row>
                </Form>
              );
            }}
          </Formik>
        </Col>
      </Row>
    </Col>
  ) : null;
};

export default PasswordReset;
